import React, { Component } from "react";
import MaterialTable from "@material-table/core";
import { withTranslation, Trans } from "react-i18next";
import { withSize } from "react-sizeme";
import { connect } from "react-redux";
import shortid from "shortid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { withStyles, withTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import Snackbar from "@material-ui/core/Snackbar";
import DialogContent from "@material-ui/core/DialogContent";
import { ProgressBar } from "react-step-progress-bar";
import "react-step-progress-bar/styles.css";
import axios from "../AxiosClient";
import DisplayUser from "../components/user/DisplayUser";

const styles = (theme) => ({
  paper: {
    margin: 10,
    flex: 1,
  },
});

export class ManageRequiredReading extends Component {
  state = {
    tasks: [],
    instance: shortid.generate(),
    deleteDialogOpen: false,
    deletedSnackbarOpen: false,
    updatedSnackbarOpen: false,
    rrToDelete: {},
  };

  getData = () => {
    axios.get("/requiredreading/",{ withCredentials:true }).then((res) => {
      this.setState({ tasks: res.data.content.map((r) => r) });
    });
  };

  componentDidMount() {
    this.getData();
    console.log(this.props.currentUser);
  }

  render() {
    const { t, classes } = this.props;
    const columns = [
      {
        title: t("manage_rr_column_title"),
        field: "title",
      },
      {
        title: t("manage_rr_column_description"),
        field: "description",
      },
      {
        title: t("required_reading_owner"),
        field: "owner",
        editable: "never",
        customFilterAndSearch: (term, rowData) =>
          rowData.owner.userLogin.indexOf(term.toLowerCase()) > -1 ||
          rowData.owner.firstName.indexOf(term.toLowerCase()) > -1 ||
          rowData.owner.surname.indexOf(term.toLowerCase()) > -1,
        render: (rowData) => (
          <DisplayUser user={rowData.owner} userId={rowData.ownerId} />
        ),
      },
      {
        title: t("required_reading_date_created"),
        field: "created",
        type: "date",
        editable: "never",
      },
      {
        title: t("manage_rr_column_notification_date"),
        field: "alert",
        type: "date",
        editable: "never",
      },
      {
        title: t("required_reading_expiry_date"),
        field: "expiry",
        type: "date",
        editable: "never",
      },
      {
        title: t("manage_rr_users_notified"),
        field: "alerted",
        type: "boolean",
        editable: "never",
      },
      {
        title: t("manage_rr_percent_completed"),
        field: "percentCompleted",
        filtering: false,
        editable: "never",
        render: (rowData) => (
          <span>
            {`${Math.round(rowData.percentCompleted)}%`}
            <ProgressBar
              percent={rowData.percentCompleted}
              filledBackground={this.props.theme.palette.primary.main}
            />
          </span>
        ),
      },
    ];

    return (
      <div
        style={{
          overflow: "auto",
          padding: 10,
          height: "100%",
          backgroundColor: "#eae0d7",
          backgroundImage: "url('../images/background.svg')",
        }}
      >
        <MaterialTable
          columns={columns}
          data={this.state.tasks}
          editable={{
            isEditable: (rowData) =>
              rowData.ownerId === this.props.currentUser.id ||
              this.props.currentUser.userPermits.roles.systemManager,
            onRowUpdate: (newData) => {
              return new Promise((resolve) => {
                axios
                  .patch(`/requiredreading/${newData.id}`, {
                    title: newData.title,
                    description: newData.description,
                  })
                  .then(() => {
                    this.getData();
                    this.setState({ updatedSnackbarOpen: true });
                  });
                resolve();
              });
            },
          }}
          actions={[
            (rowData) => ({
              icon: "delete",
              tooltip: t("manage_rr_delete_tooltip"),
              disabled:
                rowData.ownerId !== this.props.currentUser.id &&
                !this.props.currentUser.userPermits.roles.systemManager,
              onClick: (_e, rowData) => {
                this.setState({ rrToDelete: rowData }, () =>
                  this.setState({ deleteDialogOpen: true })
                );
              },
            }),
          ]}
          detailPanel={[
            {
              render: ({ rowData }) => {
                return (
                  <div style={{ display: "flex" }}>
                    <Paper className={classes.paper} elevation={2}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>
                              <Trans i18nKey="global_user" />
                            </TableCell>
                            <TableCell>
                              <Trans i18nKey="manage_rr_documents_read" />
                            </TableCell>
                            <TableCell>
                              <Trans i18nKey="manage_rr_documents_read" />
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowData.requiredReadingUsers.map((row) => (
                            <TableRow key={row.userLogin}>
                              <TableCell component="th" scope="row">
                                {`${row.firstName} ${row.surname} (${
                                  row.userLogin
                                })`}
                              </TableCell>
                              <TableCell>
                                {`${row.completedDocuments} / ${
                                  rowData.requiredReadingDocuments.length
                                }`}
                              </TableCell>
                              <TableCell>
                                <>
                                  {`${Math.round(
                                    (row.completedDocuments /
                                      rowData.requiredReadingDocuments.length) *
                                      100
                                  )}%`}
                                  <ProgressBar
                                    percent={
                                      (row.completedDocuments /
                                        rowData.requiredReadingDocuments
                                          .length) *
                                      100
                                    }
                                    filledBackground={
                                      this.props.theme.palette.primary.main
                                    }
                                  />
                                </>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Paper>
                    <Paper className={classes.paper} elevation={2}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>
                              <Trans i18nKey="global_document_plural" />
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowData.requiredReadingDocuments.map((row) => (
                            <TableRow key={row.userTitle}>
                              <TableCell component="th" scope="row">
                                {row.userTitle}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Paper>
                  </div>
                );
              },
            },
          ]}
          options={{
            pageSize: 5,
            pageSizeOptions: [5, 10, 15, 20],
            filtering: true,
            headerStyle: { position: "sticky", top: 0 },
            actionsColumnIndex: -1,
            maxBodyHeight: this.props.size.height - 200,
          }}
          onRowClick={(_event, _rowData, togglePanel) => togglePanel()}
          title={t("global_task_plural")}
        />
        <Dialog
          open={this.state.deleteDialogOpen}
          onClose={this.handleDeleteDialogClose}
          aria-labelledby="delete-dialog-title"
          aria-describedby="delete-dialog-description"
        >
          <DialogTitle id="delete-dialog-title">
            <Trans i18nKey="global_are_you_sure" />
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="delete-dialog-description">
              <Trans i18nKey="manage_rr_delete_confirm" />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDeleteDialogClose} color="primary">
              <Trans i18nKey="global_cancel" />
            </Button>
            <Button color="secondary" onClick={this.deleteConfirm}>
              <Trans i18nKey="global_delete" />
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={this.state.deletedSnackbarOpen}
          autoHideDuration={6000}
          onClose={this.handleSnackbarClose("deletedSnackbarOpen")}
          message={t("manage_rr_deleted_snack")}
        />
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={this.state.updatedSnackbarOpen}
          autoHideDuration={6000}
          onClose={this.handleSnackbarClose("updatedSnackbarOpen")}
          message={t("manage_rr_updated_snack")}
        />
      </div>
    );
  }

  handleSnackbarClose = (stateKey) => () => {
    this.setState({ [stateKey]: false });
  };

  handleDeleteDialogClose = () => {
    this.setState({ deleteDialogOpen: false });
  };

  deleteConfirm = () => {
    axios.delete(`/requiredreading/${this.state.rrToDelete.id}`).then(() => {
      this.handleDeleteDialogClose();
      this.getData();
      this.setState({ deletedSnackbarOpen: true });
    });
  };
}
const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
});

export default connect(
  mapStateToProps,
  null
)(
  withTranslation()(
    withSize({ monitorHeight: true })(
      withStyles(styles)(withTheme(ManageRequiredReading))
    )
  )
);
